import { render, staticRenderFns } from "./MyLike.vue?vue&type=template&id=fcc01324&scoped=true"
import script from "./MyLike.vue?vue&type=script&lang=js"
export * from "./MyLike.vue?vue&type=script&lang=js"
import style0 from "./MyLike.vue?vue&type=style&index=0&id=fcc01324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f87e3863bbacd24b3d835a89ae544fd6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc01324",
  null
  
)

export default component.exports